"use client";
import {useState} from 'react';

export function useBitePresentation(available:boolean, immersive=true, revealed=false) {
  const [fullscreen,setFullscreen]=useState(immersive);
  const [endingFinished,setEndingFinished]=useState(!immersive||revealed);
  const ready=available&&(endingFinished||!fullscreen||revealed);
  const phase=available&&!ready?'ending':'generation';
  const changeFullscreen=(expanded:boolean)=>{setFullscreen(expanded);if(!expanded)setEndingFinished(true);};
  return {fullscreen,ready,phase:phase as 'ending'|'generation',changeFullscreen,finish:()=>setEndingFinished(true)};
}
